// pwa-src/components/sign-in/SignInFlow.tsx
import React from 'react';
import { SignIn } from './SignIn'; // Adjust path

export const SignInFlow: React.FC = () => {
    // No state needed here anymore

    // return (
    //     {/* //Temporary disable splash screen
    //     // <SplashScreen
    //     //     // --- IMPORTANT: Replace with your actual splash image URL ---
    //     //     imageUrl="/images/logos/madam_jackal_splash.jpeg"
    //     //     // Optional: Adjust durations if needed
    //     //     // fadeInDuration={0.8}
    //     //     // visibleDuration={0.8}
    //     //     // fadeOutDuration={0.8}
    //     //     // Background color defaults to black, can override if needed:
    //     //     // backgroundColor="#121212"
    //     // >
    //         */ }
    //     < SignIn />
    //     {/* </SplashScreen> */ }
    // );

    return < SignIn />
};